import { useEffect } from 'react';

export const CANONICAL_ORIGIN = 'https://supervitrineofertas.com';

const PUBLIC_PATHS = new Set([
    '/', '/categorias', '/cupons', '/baixar-app', '/planos', '/sobre',
    '/privacidade', '/termos', '/exclusao-de-dados',
]);
const ALIASES = { '/precos': '/planos', '/downloads': '/baixar-app' };

/** Only real public routes get a canonical. Search/private routes get noindex.
 * Home consumes categoria and sort; other public routes consume only path params.
 * An allowlist prevents tracking, OAuth codes and arbitrary query keys leaking
 * into canonical URLs. It does not modify navigation, filters or authentication.
 */
export function routeSeo(pathname, search = '') {
    const normalized = (pathname || '/').replace(/\/+$/, '') || '/';
    const path = ALIASES[normalized] || normalized;
    const indexable = PUBLIC_PATHS.has(path) || /^\/(oferta|loja)\/[^/]+$/.test(path);
    if (!indexable) return { canonical: null, robots: 'noindex,follow' };

    const query = new URLSearchParams();
    if (path === '/') {
        const params = new URLSearchParams(search);
        const category = params.get('categoria');
        const sort = params.get('sort');
        if (category) query.set('categoria', category);
        if (['hot', 'discount', 'price'].includes(sort)) query.set('sort', sort);
    }
    const suffix = query.toString();
    return {
        canonical: CANONICAL_ORIGIN + path + (suffix ? `?${suffix}` : ''),
        robots: 'index,follow',
    };
}

export function applyRouteSeo(doc, policy) {
    // A single owner avoids stale/duplicate metadata during SPA navigation.
    doc.head.querySelectorAll('link[rel="canonical"], meta[name="robots"]').forEach(node => node.remove());
    if (policy.canonical) {
        const link = doc.createElement('link');
        link.rel = 'canonical';
        link.href = policy.canonical;
        doc.head.appendChild(link);
    }
    const robots = doc.createElement('meta');
    robots.name = 'robots';
    robots.content = policy.robots;
    doc.head.appendChild(robots);
}

export default function useRouteSeo({ pathname, search }) {
    useEffect(() => {
        applyRouteSeo(document, routeSeo(pathname, search));
    }, [pathname, search]);
}
